import React, { useState, useCallback, lazy, Suspense } from "react";
import { Link, NavLink } from "react-router-dom";
import LogoImg from "../../assets/Logo/Raahi_Sathi_Logo.png";
import { FaPhoneAlt } from "react-icons/fa";
import { MdOutlineSupportAgent, MdManageAccounts } from "react-icons/md";
import { RiMenu3Fill, RiMenu5Line } from "react-icons/ri";

const ResponsiveMenu = lazy(() => import("./ResponsiveMenu"));

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
  }, []);

  return (
    <nav className="fixed w-full top-0 bg-background dark:bg-darkBackground z-50 shadow-lg dark:border-b dark:border-secondary">
      <div className="container mx-auto px-4 flex justify-between items-center py-2">
        {/* Logo Section */}
        <Link to="/" className="flex items-center space-x-2 hover:scale-110">
          <img src={LogoImg} alt="Raahi Sathi Logo" className="h-14 w-14 rounded-full" />
          <h1 className="hidden sm:flex text-2xl text-primary dark:text-darkAccent font-bold">
            Raahi<span className="text-secondary dark:text-darkAccent">Sathi</span>
          </h1>
        </Link>

        {/* Contact Section */}
        <div className="flex items-center px-3 py-2 rounded-full bg-white dark:bg-darkSecondary">
          <p className="flex items-center text-primary dark:text-darkText font-bold md:text-2xl">
            <span className="hidden sm:flex items-center bg-primary text-secondary dark:text-darkAccent px-2 py-1 rounded-full mr-2">
              <FaPhoneAlt className="mr-1" /> 24x7
            </span>
            0 80 8834 2470
          </p>
        </div>

        {/* Icons and Menu Button */}
        <div className="flex items-center gap-6">
          <NavLink to="/contactus" className="hidden sm:block text-black dark:text-darkText hover:text-primary dark:hover:text-darkAccent hover:scale-110">
            <MdOutlineSupportAgent className="text-2xl" /> Help
          </NavLink>
          <NavLink to="/login" className="hidden sm:block text-black dark:text-darkText hover:text-primary dark:hover:text-darkAccent hover:scale-110">
            <MdManageAccounts className="text-2xl" /> Login
          </NavLink>
          <button onClick={toggleMenu} className="text-black dark:text-darkText text-2xl hover:text-primary dark:hover:text-darkAccent">
            {isMenuOpen ? <RiMenu5Line /> : <RiMenu3Fill />}
          </button>
        </div>
      </div>
      <Suspense fallback={<div>Loading...</div>}>
        <ResponsiveMenu isOpen={isMenuOpen} closeMenu={toggleMenu} />
      </Suspense>
    </nav>
  );
};

export default Navbar;